import React, { useRef, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import Preloader from './component/Preloader/Preloader';
import Home from './component/Home/Home';
import About from './component/About/About';
import Works from './component/works/Works';
import Skills from './component/Skills/Skills';
import Contact from './component/Contact/Contact';

export default function Mainlayout({ isLoading }) {
  const projectsSectionRef = useRef(null);

  useEffect(() => {
    if (projectsSectionRef.current) {
      projectsSectionRef.current.scrollIntoView({ behavior: 'auto' });

      setTimeout(() => {
        projectsSectionRef.current.classList.remove('scrollable');
      }, 500);
    }
  }, []);

  return (
    <div className='mainlayout'>
      <AnimatePresence mode='wait'>
        {isLoading && <Preloader />}
      </AnimatePresence>
      <Home />
      <About />
      <Skills />
      <div ref={projectsSectionRef}>
        <Works />
      </div>
      <Contact />
    </div>
  );
}
